import { Injectable } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { ConfigService } from '../config/config.service';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { JurisdictionService } from '../geo/jurisdiction.service';

@Injectable({
  providedIn: 'root'
})
export class LimitsService {

  public customer: CustomerModel;
  constructor(
    private userSession: UserSessionService,
    private webservice: WebservicesService,
    private configService: ConfigService,
    private jurisdiction: JurisdictionService,
    private navigator: Navigator
  ) {

    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );

  }

  /*
     *  GET /cashier/get-global-payment-limits
    */
  callGetGlobalPaymentLimits() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken
    }
    return this.webservice.get('cashier/get-global-payment-limits', obj);
  }

  onCloseCommon(firstLogin: boolean) {
    if (firstLogin) {
      const config = this.configService.getConfig();
      if (this.configService.isFeatureON( config, 'FEATURE_GEOLOCATION_ENFORCED_ON_LOGIN', false)) {
        this.jurisdiction
          .verifyJurisdiction(() => { })
          .then((geoResp: GeoResponse) => {
            console.log('Signup Result geo check');
          })
          .catch((err) => {
            console.log("Signup Result: launch aborted.", err);
          });
      } else {
        this.navigator.dismissAll();
      }
    } else {
      this.navigator.dismissAll();
    }
  }

  onBackCommon(firstLogin: boolean) {
    if (firstLogin) {
      this.navigator.navigateTo("SignupResultComponent", { forceModal: true });
    } else {
      this.navigator.back();
    }
  }
}
